export const splitCapitalize = (code) => {
    if(!code) return
    const [city, _] = code?.split(" - ");
    const capitalizedCity = city?.charAt(0)?.toUpperCase() + city?.slice(1);
    return capitalizedCity;
  };
